import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';


// export interface BreadcrumbItem {
//   label: string;
//   route?: string; // optional — current page won't have a route
// }
export interface BreadcrumbItem {
  label: string;
  route?: string;
  highlight?: boolean;
}

@Component({
  selector: 'app-page-breadcrumb',
  imports: [
    RouterModule,
    CommonModule
  ],
  templateUrl: './page-breadcrumb.component.html',
  styles: ``
})
export class PageBreadcrumbComponent {
  @Input() pageTitle = '';

  @Input() breadcrumbs: BreadcrumbItem[] = [];
}
